// extracted by mini-css-extract-plugin
export default {"PriceWrapper":"DollarDiscountItem_PriceWrapper__hVjFj"};